<template>
  <BaseLinkButton
    :class="sizeClass"
    :data-testid="dataTestId"
    class="tw:font-bold tw:border tw:bg-blue-700 tw:border-blue-700 tw:text-white tw:text-wrap tw:flex tw:items-center box-size-44 tw:px-6 tw:py-2 tw:text-base tw:rounded-lg tw:line-height-260 tw:hover:no-underline tw:hover:bg-blue-800 tw:hover:border-blue-800 tw:disabled:bg-gray-300 tw:disabled:border-gray-300"
    v-bind="$attrs"
  >
    <slot />
  </BaseLinkButton>
</template>

<script setup>
import { computed } from 'vue'
import BaseLinkButton from './BaseLinkButton.vue'

const props = defineProps({
  dataTestId: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'big',
  },
})

const sizeClass = computed(() => {
  if (props.size === 'small') return 'tw:px-3 tw:py-0.5 tw:text-xs tw:rounded line-height-150'
  if (props.size === 'medium') return 'box-size-36 tw:px-4 tw:py-2 tw:text-sm tw:rounded-lg line-height-180'
  else return 'box-size-44 tw:px-6 tw:py-2 tw:text-base tw:rounded-lg line-height-260'
})
</script>
